<template>
  <h1 class="result-title">Notes</h1>
  <div class="content">
    <form @submit.prevent="addNote">
      <div class="note-grid">
        <textarea
          id="story"
          name="story"
          rows="3"
          v-model.trim="addNoteRequest.note"
          required
        >
        </textarea>
        <button class="btn" type="submit">+</button>
      </div>
    </form>

    <div class="note-grid">
      <div
        v-if="userNotes"
        class="user-notes"
        v-for="(note, index) in userNotes.userNotes"
        :key="index"
      >
        <p>{{ note.noteText }}</p>
        <p class="author">
          <strong>Author: </strong> {{ note.customerServiceStaffName }}
        </p>
        <p class="date">{{ note.createDate }}</p>
        <br />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import userService from "../services/user-service";
import AddUserNoteRequest from "../requests/AddUserNoteRequest";
import GetUserNotesResponse from "../responses/GetUserNotesResponse";
import { showAlert } from "../utils/global";

export default defineComponent({
  name: "Notes",
  setup() {
    const route = useRoute();
    const userId = route.params.userId;
    const userNotes = ref<GetUserNotesResponse | null>(null);
    const addNoteRequest = ref<AddUserNoteRequest>({
      userId: Number(userId),
      note: "",
    });

    const getUserNotes = async () => {
      const notes = await userService.getUserNotes(Number(userId));
      return notes;
    };

    onMounted(async () => {
      const notes = await getUserNotes();
      if (notes) {
        userNotes.value = notes;
      }
    });

    const addNote = async () => {
      try {
        var addNoteResponse = await userService.insertUserNote(
          addNoteRequest.value
        );

        if (addNoteResponse.isSuccess) {
          showAlert("Success", "Note added successfully", "success");
          userNotes.value = await getUserNotes();
          addNoteRequest.value.note = "";
        } else {
          showAlert("Error", "Failed to add note", "error");
          userNotes.value = await getUserNotes();
        }
      } catch (error) {
        showAlert("Error", "Failed to add note", "error");
        userNotes.value = await getUserNotes();
      }
    };

    return {
      userNotes,
      addNoteRequest,
      addNote,
    };
  },
});
</script>

<style scoped>
.result-title {
  position: relative;
  background-color: var(--clr-primary);
  min-height: 89px;
  align-content: center;
  padding: 1rem 1rem;
  margin-inline: 2rem;
  color: white;
  font-size: 24px;
  border-radius: 3px;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42),
    0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.note-grid {
  display: grid;

  position: relative;
}

textarea {
  padding: 1rem 2rem;
  font-size: 20px;
}

.content {
  overflow-x: auto;
  position: relative;
  background-color: #fff;
  padding: 80px 40px 20px 40px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 3px;
  margin-top: -50px;
  padding-inline: 10px;
  padding-top: -30px;
}

.btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  background-color: var(--clr-primary);
  cursor: pointer;
  height: 50px;
  width: 50px;
  color: white;
  font-size: 24px;
  border-radius: 50%;
  border: none;
}

.content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.user-notes {
  border-top: #999 solid 1px;
  padding: 1rem 1rem 0rem 1rem;
}

.author,
.date {
  font-size: 12px;
}

strong {
  font-weight: 900;
}
</style>
